import {
	browserTracingIntegration,
	init,
	replayIntegration,
} from '@sentry/astro';

import config from './sentry.config.mjs';

const REPLAY_SAMPLE_RATE = 0.1;

const integrations = [
	browserTracingIntegration(),
	replayIntegration({
		blockAllMedia: true,
		maskAllInputs: true,
		maskAllText: true,
	}),
];

init({
	...config,
	integrations:
		typeof config.integrations === 'function'
			? config.integrations(integrations)
			: [...(config.integrations ?? []), ...integrations],
	replaysOnErrorSampleRate: 1.0,
	replaysSessionSampleRate: import.meta.env.PROD ? 0 : REPLAY_SAMPLE_RATE,
});
